import React from "react";

const ItemObject = ({ object }: { object: any }) =>
    !!object ? <span className="activity-item-object">
        {object.name}
    </span> : null

export default ItemObject;